<template>
  <div>
    <van-popup
      v-model="popupShow"
      :close-on-click-overlay="false"
      position="bottom"
      get-container="#app"
      class="pay_password_popup"
    >
      <div class="verify_popup">
        <img :class="$store.state.isMirroring && 'mirror'" class="close" src="@/assets/close.png" @click="closePopup" />
        <div class="title">{{ $t('paymentCode.payPwdNote') }}</div>
        <div class="sub_title">{{ $t('paymentCode.payPwdNote') }}</div>
        <div class="code_wrap">
          <div :class="['code flex-center', codes.length === 0 && showKeyboard && 'active']" @click="showKeyboard = true">
            {{ codes.length >= 1 ? '*' : '' }}
          </div>
          <div :class="['code flex-center', codes.length === 1 && 'active']" @click="showKeyboard = true">
            {{ codes.length >= 2 ? '*' : '' }}
          </div>
          <div :class="['code flex-center', codes.length === 2 && 'active']" @click="showKeyboard = true">
            {{ codes.length >= 3 ? '*' : '' }}
          </div>
          <div :class="['code flex-center', codes.length === 3 && 'active']" @click="showKeyboard = true">
            {{ codes.length >= 4 ? '*' : '' }}
          </div>
          <div :class="['code flex-center', codes.length === 2 && 'active']" @click="showKeyboard = true">
            {{ codes.length >= 5 ? '*' : '' }}
          </div>
          <div :class="['code flex-center', codes.length === 3 && 'active']" @click="showKeyboard = true">
            {{ codes.length >= 6 ? '*' : '' }}
          </div>
        </div>
        <div class="format_text">{{ $t('paymentCode.payPwdFormatToast') }}</div>
      </div>
    </van-popup>
    <van-number-keyboard
      :show="popupShow && showKeyboard"
      :hide-on-click-outside="false"
      @blur="showKeyboard = false"
      @input="onKeyBoardInput"
      @delete="codes.pop()"
      get-container="#app"
      :z-index="Z_INDEX_KEYBOARD"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Vant from 'vant'
import md5 from 'js-md5'
import { Toast } from 'vant'
import interceptSystemBack from '@/mixins/interceptSystemBack'
import { Z_INDEX_KEYBOARD } from '@/utils/constants'

Vue.use(Vant)

export default {
  name: 'CheckPayPassword',
  mixins: [interceptSystemBack],
  data() {
    return {
      Z_INDEX_KEYBOARD,
      value: '',
      errorInfo: '',
      showKeyboard: false,
      popupShow: false,
      codes: []
    }
  },
  props: {
    show: Boolean,
    onSuccess: Function,
    onFailed: Function,
    onClose: Function
  },
  watch: {
    show(value) {
      this.popupShow = value
      this.showKeyboard = value
      this.value = ''
      this.errorInfo = ''
      this.codes = []
      if (value) {
        this.startBackTrap()
      } else if (this._skipStopBackTrap) {
        this._skipStopBackTrap = false
        this.clearBackTrap()
      } else {
        this.stopBackTrap()
      }
    },
    codes: {
      handler(value) {
        if (value.length === 6) {
          this.checkPayPassword()
            .then((res) => {
              this.errorInfo = ''
              if (this.onSuccess) {
                this.showKeyboard = false
                setTimeout(() => {
                  this.onSuccess(res)
                }, 0)
              }
            })
            .catch((err) => {
              Toast(this.$t('paymentCode.payPwdWrongToast'))
              this.codes = []
              if (this.onFailed) {
                this.onFailed(err)
              }
            })
        } else {
          this.errorInfo = ''
        }
      },
      deep: true
    }
  },
  methods: {
    checkPayPassword() {
      return new Promise((resolve, reject) => {
        const data = {
          payPassword: md5(this.codes.join(''))
        }
        this.$http
          .post(window.serverPath + '/api/auth/checkPayPassword', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              resolve(res.data.data)
            } else {
              reject('Payment password verification failed!')
            }
          })
          .catch((err) => reject(err))
      })
    },
    onKeyBoardInput(value) {
      this.codes.push(value)
    },
    onSystemBack() {
      if (this.showKeyboard) {
        this.showKeyboard = false
        return true
      }
      if (this.popupShow) {
        this._skipStopBackTrap = true
        this.closePopup(true)
      }
      return false
    },
    closePopup(fromPopstate) {
      this.popupShow = false
      this.codes = []
      this.showKeyboard = false
      this.value = ''
      this.errorInfo = ''
      if (fromPopstate !== true) {
        this.stopBackTrap()
      }
      if (this.onClose) {
        this.onClose()
      }
    },
    beforeClose(action, done) {
      if (this.onClose) {
        this.onClose()
        done()
      }
    }
  }
}
</script>

<style scoped>
.payment-title {
  margin-bottom: 0.18rem;
}

.verify_popup {
  height: 4.8rem;
  padding: 0.24rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}

.title {
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  margin-bottom: 0.04rem;
  max-width: calc(100% - 0.4rem);
  text-align: start;
}

.sub_title,
.account {
  display: flex;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
}

.code_wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 0.4rem;
  width: 3.35rem;
}

.code_wrap .code {
  width: 0.42rem;
  height: 0.6rem;
  font-size: 0.36rem;
  font-family: 'PingFang SC';
  text-align: center;
  color: #3fbb70;
  background: rgba(63, 187, 112, 0.15);
  border-radius: 0.12rem;
  gap: 0.1rem;
  flex-shrink: 0;
  font-style: normal;
  font-weight: 400;
  line-height: 0.7rem;
}
.format_text {
  margin-top: 0.12rem;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
}
</style>
<!--全局css-->
<style>
.payment-dialog .van-dialog__content {
  padding: 0.18rem;
}

.pay_password_popup.van-popup {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckPayPassword.vue